import { BaseInitialState, State } from 'src/types'
import { baseInitialState, initialPersonalState, initialGloveImagesState } from 'src/constants'
import { initialYouthState } from '../../japan/slice/youth'

const unselectedStateKo = { label: '미선택', value: 'unselected' }
const unselectedColorStateKo = { label: '미선택', value: 'unselected', color: '#fff' }
const unselectedStateWithPriceKo = { label: '미선택', value: 'unselected', price: 0 }

const baseInitialStateKo: BaseInitialState = {
  // トップページのloading
  isLoading: false,
  backStyle: unselectedStateKo,
  dominantArm: unselectedStateKo,
  size: unselectedStateKo,
  fingerGuardType: unselectedStateKo,
  baseModel: {
    productNumber: '',
    imageUrl: '',
    dominantArm: '미선택',
    position: 'infielder', // 本当はここ、infielderでありたくない
    size: 0,
    webParts: '',
    description: '',
    series: '',
    backStyle: '',
    imageWidth: 0,
    imageHeight: 0
  }
}

export const gloveColorInitialStateKo = {
  thumbOut: unselectedColorStateKo,
  thumbWeb: unselectedColorStateKo,
  thumbRoot: unselectedColorStateKo,
  thumbWebAndIndexWeb: unselectedColorStateKo,
  thumbIndexMiddle: unselectedColorStateKo,
  indexWeb: unselectedColorStateKo,
  indexMiddle: unselectedColorStateKo,
  indexLeftMiddleRight: unselectedColorStateKo,
  middleIndex: unselectedColorStateKo,
  middleLeftRingRight: unselectedColorStateKo,
  middleRing: unselectedColorStateKo,
  ringMiddle: unselectedColorStateKo,
  ringLeftLittleRight: unselectedColorStateKo,
  ringLittle: unselectedColorStateKo,
  littleRing: unselectedColorStateKo,
  littleOut: unselectedColorStateKo
}

export const colorInitialStateKo = {
  parts: { label: '전체', value: 'all' },
  all: unselectedColorStateKo,
  catchFace: unselectedColorStateKo,
  edge: unselectedColorStateKo,
  lace: unselectedColorStateKo,
  linings: unselectedColorStateKo,
  hamidashi: unselectedColorStateKo,
  listLiningsMaterial: unselectedColorStateKo,
  stitch: { label: '미선택', value: 'unselected', color: '#eee' },
  web: unselectedColorStateKo,
  web2: unselectedColorStateKo,
  thumbHook: unselectedColorStateKo,
  littleHook: unselectedColorStateKo,
  listBelt: unselectedColorStateKo,
  indexCover: unselectedColorStateKo
}

const initialEmbroideryState = {
  id: 0,
  typeFace: { label: '', value: '' },
  position: { label: '', value: '' },
  color: { label: '', value: '', color: '' },
  shadowColor: { label: '', value: 'none' },
  edgeColor: { label: '', value: 'none' },
  content: ''
}

export const initialInfielderStateKo: State = {
  ...baseInitialState,
  kinds: unselectedStateKo,
  tanner: unselectedStateKo,
  backLace: unselectedStateKo,
  beltType: unselectedStateWithPriceKo,
  webParts: unselectedStateKo,
  size: unselectedStateWithPriceKo,
  leatherIntegratedMiddle: unselectedStateWithPriceKo,
  loopOfRingFinger: unselectedStateWithPriceKo,
  loopOfRingFingerColor: unselectedColorStateKo,
  ...colorInitialStateKo,
  ...gloveColorInitialStateKo,
  mouton: unselectedStateKo,
  atomsLabel: unselectedStateKo,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialOutfielderStateKo: State = {
  ...baseInitialStateKo,
  ...colorInitialStateKo,
  ...gloveColorInitialStateKo,
  loopOfRingFinger: unselectedStateKo,
  loopOfRingFingerColor: unselectedColorStateKo,
  tanner: unselectedStateKo,
  backLace: unselectedStateKo,
  webParts: unselectedStateKo,
  mouton: unselectedStateKo,
  atomsLabel: unselectedStateKo,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialPitcherStateKo: State = {
  ...baseInitialStateKo,
  ...colorInitialStateKo,
  ...gloveColorInitialStateKo,
  tanner: unselectedStateKo,
  loopOfRingFinger: unselectedStateKo,
  loopOfRingFingerColor: unselectedColorStateKo,
  backLace: unselectedStateKo,
  backStyle: unselectedStateKo,
  materialPack: unselectedStateKo,
  webParts: unselectedStateKo,
  printLeatherType: unselectedStateKo,
  mouton: unselectedColorStateKo,
  atomsLabel: unselectedStateKo,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialStateFirstMittKo: State = {
  ...baseInitialStateKo,
  ...colorInitialStateKo,
  tanner: unselectedStateKo,
  loopOfRingFinger: unselectedStateKo,
  loopOfRingFingerColor: unselectedColorStateKo,
  webParts: unselectedStateKo,
  printLeatherType: unselectedStateKo,
  thumb: unselectedColorStateKo,
  underWeb: unselectedColorStateKo,
  boomerang: unselectedColorStateKo,
  mouton: unselectedStateKo,
  atomsLabel: unselectedStateKo,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialStateCatcherMittKo: State = {
  ...baseInitialStateKo,
  ...colorInitialStateKo,
  tanner: unselectedStateKo,
  backStyle: unselectedStateKo,
  thumb: unselectedColorStateKo,
  webParts: unselectedStateKo,
  printLeatherType: unselectedStateKo,
  thumbIndexMiddleRight: unselectedColorStateKo,
  catchFaceTarget: unselectedColorStateKo,
  indexAndMiddle: unselectedColorStateKo,
  middleRing: unselectedColorStateKo,
  middleLeftRingLittle: unselectedColorStateKo,
  middleLeftRing: unselectedColorStateKo,
  littleRing: unselectedColorStateKo,
  littleOut: unselectedColorStateKo,
  fingerStand: unselectedColorStateKo,
  indexFingerTipOut: unselectedColorStateKo,
  mouton: unselectedColorStateKo,
  atomsLabel: unselectedStateKo,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

// 韓国人が、USモデルをオーダーする際の初期値
export const initialUsGloveStateKo: State = {
  ...baseInitialStateKo,
  tanner: unselectedStateKo,
  backLace: unselectedStateKo,
  backStyle: unselectedStateKo,
  materialPack: unselectedStateKo,
  webParts: unselectedStateKo,
  moldingOrder: unselectedStateKo,
  loopOfRingFinger: unselectedStateKo,
  ...colorInitialStateKo,
  ...gloveColorInitialStateKo,
  mouton: unselectedStateKo,
  atomsLabel: unselectedStateKo,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const initialYouthStateKo = initialYouthState // 韓国版は無いため、jaのobjectを流用
